import { RootState } from 'store'

export const reviewsSelectors = {
  selectPendingCount: (state: RootState) => state.reviews.pendingCount
}
